export default "__VITE_ASSET__BWvIx9vP__"